import React, { Component } from 'react';
import ModalView from 'react-modal';

import './Modal.css';

if (process.env.NODE_ENV !== 'test') ModalView.setAppElement('#root');

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isButtonClose: (props.isButtonClose !== undefined) ? props.isButtonClose : true,
      style: props.style,
      className: props.className || '',
      title: props.title || false,
      footer: props.footer || false,
      content: props.content || false,
      modalIsOpen: props.isOpen || false
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  setContent(content) {
    this.setState({content});
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  titleModal() {
    if (this.state.title) {
      return (
        <div className="modal-header">
          {this.state.title}
        </div>
      );
    }
  }

  contentModal() {
    if (this.state.content) {
      return (
        <div className="modal-content">
          {this.state.content}
        </div>
      );
    }
  }

  footerModal() {
    if (this.state.footer) {
      return (
        <div className="modal-footer">
          {this.state.footer}
        </div>
      );
    }
  }

  render() {
    console.log(1);
    return (
      <ModalView
        style={this.state.style}
        isOpen={ this.state.modalIsOpen }
        onAfterOpen={ this.afterOpenModal }
        onRequestClose={ this.closeModal }
        className={"container c-modal " + this.state.className }
        contentLabel="Modal"
      >
        {(this.state.isButtonClose) ? <button className="modal-close" onClick={this.closeModal}>×</button> : ''}
        {this.titleModal()}
        {this.contentModal()}
        {this.footerModal()}
      </ModalView>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.jsx